/* eslint-disable @next/next/no-img-element */
import { envs } from "@/utils/constants";
import { CloseIcon } from "@mantine/core";
import Cookies from "js-cookie";
import Link from "next/link";
import { CSSProperties, useState } from "react";
import { getPageRoute, getS3ImageUrl } from "../../utils/routes";
import classes from "./WelcomePopup.module.css";

interface Props {
  className?: string;
  style?: CSSProperties;
  image?: PopupWidgetImage;
  mobile?: PopupWidgetImage;
  onClose?: () => void;
}

const WelcomePopup = ({ className, style, image, mobile, onClose }: Props) => {
  const [show, setShow] = useState(true);

  const classNames = [classes.WelcomePopup, className];

  if (!show) classNames.push(classes.close);

  const handleClose = () => {
    setShow(false);

    if (onClose) {
      setTimeout(() => {
        onClose();
      }, 200);
    }
  };

  const images: PopupWidgetImage[] = [];

  if (image) images.push(image);
  if (mobile && mobile.url) images.push(mobile);
  else if (image) images.push(image);

  return (
    <div className={classNames.join(" ")} style={style}>
      <div className={classes.content}>
        {/* close button */}
        <button onClick={handleClose} className={classes.closeButton}>
          <CloseIcon size="1rem" />
        </button>

        {/* <Image 
                        src={getS3ImageUrl(image?.url || '', 'MEDIA') || '/images/placeholder.png'}
                        alt={image?.name || 'Welcome to Wishlist'}
                        width={800}
                        height={400}
                        objectFit='contain'
                        className={classes.image}
                        unoptimized={true}
                    /> */}

        {images.map((image, index) => (
          <div
            key={index + "-welcome-image-" + (image?.url || "")}
            className={`${
              images.length > 1
                ? index === 0
                  ? classes.desktop
                  : classes.mobile
                : ""
            }`}
          >
            <Link
              href={
                image?.link?.url
                  ? getPageRoute(
                      (image?.link?.urlType || "custom") as any,
                      image?.link?.url
                    )
                  : "#"
              }
              onClick={(e) => {
                if (!image?.link?.url) {
                  e.preventDefault();
                  return;
                }

                handleClose();
              }}
              passHref
            >
              <img
                src={
                  getS3ImageUrl(image?.url || "", "MEDIA") ||
                  "/images/placeholder.png"
                }
                alt={image?.name || "Welcome to Wishlist"}
                className={classes.image}
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export const checkClosedTime = (time: number) => {
  const closedCount = Number(Cookies.get(envs.welcomePopupCountKey) || "0") + 1;

  Cookies.set(envs.welcomePopupCountKey, closedCount.toString(), {
    expires: 1 - closedCount / time / 2,
  });

  return closedCount < time;
};

export const getWelcomeHashKey = (
  image: PopupWidgetImage | undefined,
  resetTime: number = 1
) => {
  if (!image) return "";
  return `${image.url || ""}-${resetTime}`;
};

export default WelcomePopup;
